import { reactive } from 'vue'

const state = reactive({ items: [] })
let sequence = 0

function remove(id) {
  const index = state.items.findIndex((item) => item.id === id)
  if (index >= 0) state.items.splice(index, 1)
}

function show(message, tone = 'success') {
  const id = ++sequence
  state.items.push({ id, message, tone })
  window.setTimeout(() => remove(id), 4200)
  return id
}

export function useToast() {
  return { state, show, remove }
}
